// extracted by mini-css-extract-plugin
export default {"counterContainer":"CounterButton_counterContainer__rZ9ua","button":"CounterButton_button__7kutg","count":"CounterButton_count__HP-Sb"};